export const COMPANY_OWNER_CODES = { CO003: 'PHONE_NUMBER_ALREADY_ASSIGNED' };
